<template>
    <div>
        <div class="card-bind">
            <van-nav-bar title="投诉与建议" @click-left="onClickLeft" left-text="返回" left-arrow></van-nav-bar>
            <div class="page-content">
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">卡板编号</label>
                                <div class="md-field-item-control">
                                    <input max="20" name="iccid" v-model="form.iccid" placeholder="请输入充值号" maxlength="" autocomplete="off"
                                           type="text" class="md-input-item-input">
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">联系姓名</label>
                                <div class="md-field-item-control">
                                    <input max="20" name="name" v-model="form.name" placeholder="请填写您的姓名" maxlength="" autocomplete="off"
                                           type="text" class="md-input-item-input">
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">联系电话</label>
                                <div class="md-field-item-control">
                                    <input max="20" name="mobile" v-model="form.mobile" placeholder="请填写您的电话" maxlength="" autocomplete="off"
                                           type="text" class="md-input-item-input">
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">问题描述</label>
                                <div class="md-field-item-control">
                                    <input name="remark" rows="2" v-model="form.desc" placeholder="请描述您所遇到的问题" autocomplete="off"
                                           type="textarea" class="md-input-item-input">
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">上传截图</label>
                                <div class="md-field-item-control">
                                    <van-uploader v-model="fileList" preview-size="60px"
                                                  :max-count="6" multiple />
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">

                        <div  @click="handleBindCard" class="md-button primary active block">
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>提交</span></div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <template v-if="customerServiceInfo.customerServiceCode">
                    <p style="
                    text-align: center;
                    color: #ff5257;
                    font-size: 0.4rem;
                    line-height: 10px;
                    padding: 0;
                    margin: 10px;">
                        请添加人工客服处理
                    </p>
                </template>
                <van-image
                        v-if="customerServiceInfo.customerServiceCode"
                        width="180"
                        style="display:block;margin: 0 auto"
                        :src="customerServiceInfo.customerServiceCode"
                />
                <a style="text-align: center;display: block;margin: 0 auto;" v-if="customerServiceInfo.customerServiceMobile" :href="'tel:'+customerServiceInfo.customerServiceMobile">
                    <van-button plain icon="phone-o" type="info" size="small" >
                    拨打投诉电话
                    </van-button>
                </a>
                <p style="text-align: center;font-size: .3rem">{{customerServiceInfo.customerServiceTime}}</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "bind",
        data() {
            return {
                customerServiceInfo:{},
                form:{},
                fileList:[],
                files:[],
            };
        },
        methods: {
            handleBindCard(){
                this.$toast.loading('提交中')
                let files = [];
                for (let i in this.fileList){
                    files.push(this.fileList[i].file)
                }
                this.upload('/user/feedback',files,this.form,(res)=>{
                    this.$toast.loading().clear();
                    if(res.code){
                        this.$toast.success(res.msg)
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            getCustomerServiceInfo(){
                this.fetchData('/config/getCustomerServiceInfo',{},(res)=>{
                    if(res.code){
                        this.customerServiceInfo = res.data
                    }
                })
            }
        },
        created() {
            this.getCustomerServiceInfo()
            let query = this.$route.query
            this.form.iccid = query.iccid
        }
    };
</script>
<style>
    .md-field-item {
        position: relative;
        border-bottom: 1px solid #f3f3f3;
    }

    .md-field-item-right {
        position: relative;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-left: .12rem;
        display: -webkit-inline-flex;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        color: #858b9c;
        font-size: .28rem;
    }

    .card-bind .input-operator {
        color: #75b2f9;
    }

    .md-input-item.is-error .md-field-item-content:before {
        content: "";
        position: absolute;
        z-index: 2;
        -webkit-transform-origin: 100% 50%;
        transform-origin: 100% 50%;
        -webkit-transform: scaleY(.5) translateY(100%);
        transform: scaleY(.5) translateY(100%);
        bottom: 0;
        left: 0;
        right: auto;
        top: auto;
        width: 100%;
        border-bottom: .04rem solid #ff5257;
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
    }

    .md-field-item-content:before {
        content: "";
        position: absolute;
        z-index: 2;
        -webkit-transform-origin: 100% 50%;
        transform-origin: 100% 50%;
        -webkit-transform: scaleY(.5) translateY(100%);
        transform: scaleY(.5) translateY(100%);
        bottom: 0;
        left: 0;
        right: auto;
        top: auto;
        width: 100%;
        border-bottom: .02rem solid #e2e4ea;
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
    }

    .md-field-item-children {
        font-size: .24rem;
        margin-top: .2rem;
    }

    .md-input-item-msg {
        font-size: .24rem;
        color: #ff5257;
    }

    .md-input-item-brief, .md-input-item-msg {
        word-break: break-all;
        word-wrap: break-word;
    }

    .md-button {
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.36rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        -webkit-appearance: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0.04rem;
        outline: 0px;
        transition: all 0.3s ease 0s;
        overflow: visible;
        position: relative;
    }


    .md-button.primary {
        background: #2f86f6;
        color: #fff;
    }

    .md-button.block {
        width: 100%;
    }

    .md-button.inactive {
        opacity: .3;
    }

    .md-button-inner {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        word-wrap: break-word;
        white-space: nowrap;
    }

    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #c3c3c3;
    }

    ::-moz-placeholder { /* Firefox 19+ */
        color: #c3c3c3;
    }

    :-ms-input-placeholder { /* IE 10+ */
        color: #c3c3c3;
    }

    :-moz-placeholder { /* Firefox 18- */
        color: #c3c3c3;
    }

    .md-button-content {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        padding: 0 .06rem;
    }

    .md-field-item-content {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        min-height: 1rem;
        box-sizing: border-box;
    }

    .page-content {
        padding-bottom: .1rem;
        min-height: 6rem;
        border-radius: 0 0 .2rem .2rem;
        background: #fff;
    }

    .card-bind {
        background: #fff;
        font-size: .12rem;
        margin: .2rem auto;
        -webkit-box-shadow: 0 0 1px #dedede;
        box-shadow: 0 0 1px #dedede;
        border-radius: .1rem;
    }

    .md-field {
        padding: .1rem .2rem;
        border: none;
    }

    .md-field-item-title {
        text-align: left;
        width: 1.6rem;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        font-size: .32rem;
    }

    .md-field-item-control {
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
    }

    .md-field-item.is-solid .md-field-item-title {
        width: 1.6rem;
    }

    .md-field-item-title {
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-right: .1rem;
        font-size: .32rem;
    }

    .md-field-item-control {
        text-align: left;
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
        padding: 0;
        margin: 0;
        line-height: 1.15;
        border: none;
        background: none;
        outline: none;
        border: 0;
    }

    .card-bind .page-title {
        margin: .3rem 0 0 0;
        font-size: .3rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: .2rem .2rem 0 0;
        border-bottom: 1px solid #fafafa;
        color: #888;
        text-align: center;
    }

    .md-input-item-input {
        width: 100%;
        height: 1rem;
        color: rgb(17, 26, 52);
        font-size: 0.32rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        line-height: 1;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: 0px 0px;
        outline: 0px;
        border: none;
    }

    .md-field-item-control {
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
    }

    .md-field-footer {
        margin-top: .2rem;
    }
    .card-bind .scan img{
        width: .36rem;
        height: .36rem;
        margin-top: .08rem;
    }
    .card-bind .scan {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        font-size: .36rem;
        color: #3c6bff;
    }
    .md-icon.icon-font {
        font-size: .16rem;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        letter-spacing: 0;
        speak: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>



// WEBPACK FOOTER //
// src/pages/feedback.vue